document.addEventListener('DOMContentLoaded', function () {
  const gallery = document.querySelector('[id^="Slider-Gallery"]');
  const prevBtn = document.querySelector('[id^="GalleryViewer"] .slider-button--prev');
  const nextBtn = document.querySelector('[id^="GalleryViewer"] .slider-button--next');

  if (!gallery || !prevBtn || !nextBtn) return;

  function getActiveSlide() {
    return gallery.querySelector('.product__media-item.is-active') || gallery.querySelector('.product__media-item');
  }

  function goToSlide(direction) {
    const slides = Array.from(gallery.querySelectorAll('.product__media-item'));
    const current = getActiveSlide();

    if (!current || slides.length === 0) return;

    let index = slides.indexOf(current);
    let nextIndex = direction === 'next' ? index + 1 : index - 1;

    if (nextIndex >= slides.length) nextIndex = 0;
    if (nextIndex < 0) nextIndex = slides.length - 1;

    slides.forEach(slide => slide.classList.remove('is-active'));
    slides[nextIndex].classList.add('is-active');

    gallery.scrollTo({
      left: slides[nextIndex].offsetLeft,
      behavior: 'smooth'
    });

    const mediaId = slides[nextIndex].dataset.mediaId;
    const thumbnail = document.querySelector(`[data-target="${mediaId}"] button`);

    if (thumbnail) {
      document.querySelectorAll('[id^="GalleryThumbnails"] button').forEach(btn => {
        btn.removeAttribute('aria-current');
      });

      thumbnail.setAttribute('aria-current', 'true');
    }
  }

  nextBtn.addEventListener('click', function (e) {
   /* e.preventDefault();
    e.stopPropagation();*/
    goToSlide('next');
  });

  prevBtn.addEventListener('click', function (e) {
   /* e.preventDefault();
    e.stopPropagation(); */
    goToSlide('prev');
  });
});